import { createAction } from "redux-actions";
import { takeLatest, put, select, call } from "redux-saga/effects";
import { queryParams } from "../../../../utils/queryParams";
import axios from "axios";

export const SET_UPDATES_LOADING = "saga/SET_UPDATES_LOADING";
export const SET_FILTERS_DIRTY = "saga/SET_FILTERS_DIRTY";
export const SET_LOADING = "saga/SET_LOADING";
export const SET_TOGGLE = "saga/HANDLE_TOGGLE";
export const SET_DATES = "saga/SET_DATES";

export const FETCH_CURRENT_USER_SUCCESS = "saga/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_FILTERS_SUCCESS = "saga/FETCH_FILTERS_SUCCESS";
export const FETCH_TABLE_SUCCESS = "saga/FETCH_TABLE_SUCCESS";
export const FETCH_CURRENT_USER = "saga/FETCH_CURRENT_USER";

export const UPDATE_CHART = "saga/UPDATE_CHART";
export const UPDATE_DATES = "saga/UPDATE_DATES";
export const UPDATE_CUSTOM_RANGE = "saga/UPDATE_CUSTOM_RANGE";
export const UPDATE_FILTERS = "saga/UPDATE_FILTERS";

const API_URL = "/pages/lifetime_value_and_length/by_membership_types";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateChart: createAction(UPDATE_CHART),
  updateDates: createAction(UPDATE_DATES),
  updateCustomRange: createAction(UPDATE_CUSTOM_RANGE),
  updateFilters: createAction(UPDATE_FILTERS)
};

export default function* watchActiveMembers() {
  yield takeLatest(FETCH_CURRENT_USER, fetchCurrentUserData);
  yield takeLatest(UPDATE_CHART, fetchChart);
}

export function* fetchCurrentUserData(data) {
  yield put({
    type: FETCH_CURRENT_USER_SUCCESS,
    payload: data.payload
  });

  const { calendarEndDate, calendarStartDate } = yield select((state) => {
    return state.lifetimeValueByMembership.currentUser;
  });

  yield put({
    type: SET_DATES,
    payload: {
      startDate: calendarStartDate,
      endDate: calendarEndDate
    }
  });
  yield put({ type: SET_LOADING, payload: true });
  try {
    yield fetchFilters();
    yield fetchChart();

    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* fetchChart() {
  const { organization_id, short_url, end_date, start_date, members_view, date, membership_types } =
    yield getCommonApiParams();

  if (!membership_types.length) return;

  const params = {
    organization_id: organization_id.toString(),
    short_url,
    membership_type_ids: membership_types.map((obj) => obj.id).join(","),
    members_view: members_view.id
  };

  if (members_view.id === "all_time_members") {
    params.start_date = start_date;
    params.end_date = end_date;
  } else {
    params.date = date;
  }

  yield put({ type: SET_UPDATES_LOADING, payload: true });
  try {
    let { data: tableData } = yield call(
      axios.post,
      queryParams.apiVersion + `${API_URL}/get_table_data`,
      { ...params }
    );
    yield put({
      type: FETCH_TABLE_SUCCESS,
      payload: tableData
    });

    yield put({ type: SET_UPDATES_LOADING, payload: false });
    yield put({ type: SET_FILTERS_DIRTY, payload: false });
  } catch (err) {
    console.error(err);
  }
}

function* fetchFilters() {
  const { organization_id, short_url } = yield getCommonApiParams();

  const params = {
    organization_id,
    short_url
  };

  try {
    let { data } = yield call(axios.get, queryParams.apiVersion + `${API_URL}/get_filters`, {
      params
    });
    yield put({
      type: FETCH_FILTERS_SUCCESS,
      payload: data
    });
  } catch (err) {
    console.error(err);
  }
}

function* getCommonApiParams() {
  const { organization_id, short_url } = yield select((state) => state.commonReducer.commonProps);
  const {
    currentUser: { calendarEndDate },
    selectedFilters: { members_view, membership_types },
    selectedRequestDates: { endDate, startDate }
  } = yield select((state) => state.lifetimeValueByMembership);

  return {
    organization_id,
    short_url,
    end_date: endDate,
    start_date: startDate,
    date: calendarEndDate,
    members_view,
    membership_types
  };
}
